// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultiLineField__container-d4fa6a {
  height: 200px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/MultiLineField/MultiLineField.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF","sourcesContent":[".container {\n  height: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MultiLineField__container-d4fa6a`
};
module.exports = ___CSS_LOADER_EXPORT___;
